import { render, staticRenderFns } from "./BpayHelpText.vue?vue&type=template&id=11206d99&"
import script from "./BpayHelpText.vue?vue&type=script&lang=ts&"
export * from "./BpayHelpText.vue?vue&type=script&lang=ts&"
import style0 from "./BpayHelpText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports